
import React from 'react';
import Navbar from '../Components/Navbar/Navbar';
import Headeraide from '../Aidesocials/Headeraide';
import Cartesaidesocial from '../Aidesocials/Cartesaidesocial';
import Grandbouton from '../Aidesocials/Grandbouton';
import BackButtonUrb from '../ComponentsUrbanisme/BackButtonUrb/BackButtonUrb';
import Contact from '../Components/Contact/Contact';

import Footer from '../Components/Footer/Footer';
import Footerbas from '../Components/Footerbas/Footerbas';
import QuickActions from '../Components/QuickActions/QuickActions';
import Publicites from '../Components/Publicites/Publicites';

function Aidesocials() {
  return (
    <div>
    <Navbar/>
    <Headeraide/>
    <div className="page-avec-pub">

        {/* CONTENU */}
        <div className="page-contenu">
    <Cartesaidesocial/>
    <Grandbouton/>
    <BackButtonUrb/>
    <Contact/>
    </div>
        {/* SIDEBAR DROITE */}
        <div className="sidebar-right">

          <QuickActions />
          <Publicites />
          </div>
      </div>
    <Footer/>
    <Footerbas/>
    </div>
  );
}

export default Aidesocials;
